import { render } from "./ChannelPointsCustomRewardRedemptionAdd.vue?vue&type=template&id=577aa10e"
import script from "./ChannelPointsCustomRewardRedemptionAdd.vue?vue&type=script&lang=ts"
export * from "./ChannelPointsCustomRewardRedemptionAdd.vue?vue&type=script&lang=ts"
script.render = render

export default script